/*
 * <split-flap-countdown data-deadline="<unix epoch seconds>"
 *                       data-finished-text="NOW AVAILABLE">
 * Airport-style split-flap countdown (days/hrs/min/sec). When the deadline
 * passes, the timer is replaced by the finished text — live, no reload.
 */
if (!customElements.get('split-flap-countdown')) {
  class SplitFlapCountdown extends HTMLElement {
    connectedCallback() {
      this.deadline = parseInt(this.dataset.deadline, 10) * 1000;
      this.finishedText = this.dataset.finishedText || 'NOW AVAILABLE';
      if (!this.deadline || isNaN(this.deadline)) return;
      if (Date.now() >= this.deadline) {
        this.renderFinished();
        return;
      }
      this.build();
      this.timer = setInterval(this.tick.bind(this), 1000);
      this.tick();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    remaining() {
      var s = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      var days = Math.floor(s / 86400);
      var hours = Math.floor((s % 86400) / 3600);
      var mins = Math.floor((s % 3600) / 60);
      return { days: days, hours: hours, mins: mins, secs: s % 60 };
    }

    build() {
      var r = this.remaining();
      var dayDigits = Math.max(2, String(r.days).length);
      var digit =
        '<span class="sf-digit">' +
        '<span class="sf-half sf-top"><span>0</span></span>' +
        '<span class="sf-half sf-bottom"><span>0</span></span>' +
        '<span class="sf-half sf-flip-top"><span>0</span></span>' +
        '<span class="sf-half sf-flip-bottom"><span>0</span></span>' +
        '</span>';
      this.innerHTML = [
        ['days', dayDigits, 'Days'],
        ['hours', 2, 'Hrs'],
        ['mins', 2, 'Min'],
        ['secs', 2, 'Sec']
      ].map(function (g) {
        return '<span class="sf-group" data-key="' + g[0] + '">' +
          '<span class="sf-digits">' + new Array(g[1] + 1).join(digit) + '</span>' +
          '<span class="sf-label">' + g[2] + '</span></span>';
      }).join('');
    }

    setDigit(el, char) {
      var top = el.querySelector('.sf-top > span');
      if (top.textContent === char) return;
      var prev = top.textContent;
      el.querySelector('.sf-flip-top > span').textContent = prev;
      el.querySelector('.sf-flip-bottom > span').textContent = char;
      top.textContent = char;
      el.classList.remove('sf-flipping');
      void el.offsetWidth; /* restart the animation */
      el.classList.add('sf-flipping');
      clearTimeout(el._sfTimer);
      el._sfTimer = setTimeout(function () {
        el.querySelector('.sf-bottom > span').textContent = char;
        el.classList.remove('sf-flipping');
      }, 620);
    }

    tick() {
      if (Date.now() >= this.deadline) {
        clearInterval(this.timer);
        this.renderFinished();
        return;
      }
      var r = this.remaining();
      var self = this;
      this.querySelectorAll('.sf-group').forEach(function (group) {
        var digits = group.querySelectorAll('.sf-digit');
        var str = String(r[group.dataset.key]);
        while (str.length < digits.length) str = '0' + str;
        digits.forEach(function (d, i) { self.setDigit(d, str.charAt(i)); });
      });
    }

    renderFinished() {
      var span = document.createElement('span');
      span.className = 'sf-finished';
      span.textContent = this.finishedText;
      this.innerHTML = '';
      this.appendChild(span);
    }
  }
  customElements.define('split-flap-countdown', SplitFlapCountdown);
}
